"use client";

import React, { useContext } from "react";
import { Pagination as AntPagination } from "antd";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";

interface PaginationProps {
  page: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: number[];
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50],
}) => {
  const { theme } = useContext(CMSModal)

  return (
    <div className="flex justify-between items-center mt-6">
      {/* Page info */}
      <div className={twMerge("text-sm", theme === "dark" ? "text-white" : "")}>
        Page <span className="font-semibold ">{page}</span> of{" "}
        <span className="font-semibold">{totalPages}</span>
      </div>

      <AntPagination
        current={page}
        pageSize={pageSize}
        total={totalPages * pageSize}
        showSizeChanger
        pageSizeOptions={pageSizeOptions.map(String)}
        onChange={(p, size) => {
          onPageChange(p);
          if (size !== pageSize) onPageSizeChange(size);
        }}
        className="cms-pagination"

      />
    </div>
  );
};

export default Pagination;
